
import chartOpt from '../../chartOptions';
export default {
  data () {
    return {
      cId: '',
      communityName: '',

      actionInterval: '',
      communityInterval: '',
      termin: {},
      activeUser: {}
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.getAppData(true);
  },
  methods: {
    /* 社区页面的方法 循环调用 */
    communityFun () {
      // , 'getBuildData'
      let actionArr = ['getVerifyStatus'];
      actionArr.forEach((item) => { this[item](); });

      this.communityInterval = setInterval(() => {
        actionArr.forEach((item) => { this[item](); });
      }, this.intervalTime());
    },
    /* 两页面公用的方法 循环调用 */
    publicFun () {
      // 'userCountChart','tenmentChart','openNumChart','repairChart','getBaseData''realOpenChart',
      let chartArr = ['getAppData'];
      chartArr.forEach((item) => { // 循环调用方法
        if (item === 'getAppData') {
          this[item](true);
        } else {
          this[item]();
        }
      });

      // 'getUserCount','getNewUser','getOpenNum','repairData','getBaseData'
      let actionArr = ['getRealOpen', 'getAppData'];
      this.actionInterval = setInterval(() => { // 设置定时获取数据
        actionArr.forEach((item) => {
          this[item]();
        });
      }, this.intervalTime());
    },
    /* 饼状图不同系统终端用户比例统计、近7天活跃用户占总数比例 */
    getAppData (firstCall) {
      this.$get({
        url: '/zw_statistics/distribution_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        let activeArr = [];
        let terminalArr = [];
        if (data) {
          let active = data.active_user;
          let terminal = data.terminal;
          if (active && Object.keys(active).length) {
            let arr = [];
            let keyObj = { active: '活跃', not_active: '不活跃' };
            for (let key in active) {
              arr.push(active[key]);
              activeArr.push({ name: keyObj[key], y: active[key] });
            }
            if (arr.every(ele => ele === 0)) {
              activeArr.push({ name: '暂无数据', y: 1 });
              var activeNoData = true;
            }
          }

          if (terminal && Object.keys(terminal).length) {
            let terminalVal = [];
            for (let item in terminal) {
              terminalVal.push(terminal[item]);
              terminalArr.push({ name: item, y: terminal[item] });
            }
            if (terminalVal.every(ele => ele === 0)) {
              terminalArr.push({ name: '暂无数据', y: 1 });
              var terminalNoData = true;
            }
          }
        }

        if (firstCall) {
          this.activeUser = this.Highcharts.chart('active-user', this.changePieOption('activeUser', activeNoData));
          this.termin = this.Highcharts.chart('termin', this.changePieOption('termin', terminalNoData));
        }
        this.activeUser.series[0].setData(activeArr);
        this.termin.series[0].setData(terminalArr);
        console.log('pie data: ', terminalArr);
      });
    },
    /* 修改饼状图配置 */
    changePieOption (type, isNoData) {
      let pieOptions = chartOpt.pieOptions();
      if (isNoData === true) {
        pieOptions.plotOptions.pie.dataLabels.enabled = false;
        pieOptions.tooltip.enabled = false;
      } else {
        pieOptions.plotOptions.pie.dataLabels.enabled = true;
        pieOptions.tooltip.enabled = true;
      }
      if (this.$route.name === 'allVis' && this.cId) {
        pieOptions.plotOptions.pie.size = '50%';
        pieOptions.plotOptions.pie.startAngle = 0;
        pieOptions.plotOptions.pie.dataLabels.distance = 12;
        if (type === 'termin') {
          pieOptions.colors = ['#B8A0FF', '#8158F7', '#9D7BFF'];
        } else {
          pieOptions.colors = ['#10A75E', '#4EF1A2'];
        }
      } else {
        pieOptions.plotOptions.pie.size = '65%';
        pieOptions.plotOptions.pie.startAngle = 50;
        pieOptions.plotOptions.pie.dataLabels.distance = 12;
        if (type === 'termin') {
          pieOptions.colors = ['#B8A0FF', '#8158F7', '#9D7BFF'];
        } else {
          pieOptions.colors = ['#F98F3B', '#FFC292'];
        }
      }
      return pieOptions;
    }
  }
};
